import axios from "../../api"
import { fetchCategories } from "../../entities/slices/filtersSlice"
import { fetchRegions } from "../../entities/slices/regionsSlice"
import { AppDispatch } from "../store"


export const fetchRegionsRequest = () => 
{
    return async (dispatch: AppDispatch) => {
        try{
            const request = await axios.get('v1/regions',{

            })
            .then((response)=>{
                dispatch(fetchRegions(response.data))
            }
            )
            .catch((error)=>{
                console.log(error)
            })
        }
        catch(e){
            
        }
    }
}